/** Supported desktop platforms and file-save helpers (Step 9). */

export const BACKUP_VERSION = 1;

export function detectBackupPlatform() {
  if (typeof navigator === "undefined") return "unknown";
  const platform = String(navigator.platform || "");
  const ua = String(navigator.userAgent || "");
  if (/Win/i.test(platform) || /Windows/i.test(ua)) return "windows";
  if (/Mac/i.test(platform) || /Macintosh/i.test(ua)) return "mac";
  return "unsupported";
}

export function isBackupPlatformSupported() {
  const platform = detectBackupPlatform();
  return platform === "windows" || platform === "mac";
}

export function platformLabel(platform = detectBackupPlatform()) {
  if (platform === "windows") return "Windows PC";
  if (platform === "mac") return "Apple Mac";
  if (platform === "unsupported") return "Unsupported device";
  return "Unknown device";
}

function downloadBlob(filename, mime, body) {
  const blob = body instanceof Blob ? body : new Blob([body], { type: mime });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
  return { method: "download", filename };
}

export async function saveBackupFile({ filename, mime, body, description = "Backup file" }) {
  const blob = body instanceof Blob ? body : new Blob([body], { type: mime });
  const ext = filename.includes(".") ? filename.slice(filename.lastIndexOf(".")) : "";
  const accept = ext ? { [mime]: [ext] } : { [mime]: [] };

  if (typeof window !== "undefined" && window.showSaveFilePicker && isBackupPlatformSupported()) {
    try {
      const handle = await window.showSaveFilePicker({
        suggestedName: filename,
        types: [{ description, accept }],
      });
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();
      return { method: "picker", filename: handle.name || filename };
    } catch (err) {
      if (err?.name === "AbortError") throw err;
    }
  }

  return downloadBlob(filename, mime, blob);
}
